export enum AuthenticationService {
  GOOGLE = "google",
  FACEBOOK = "facebook",
  APPLE = "apple",
}
